/*
 * @Author: fanyang 1050549505@qq.com
 * @Date: 2021-09-30 11:57:21
 * @LastEditors: fanyang 1050549505@qq.com
 * @LastEditTime: 2022-08-29 14:10:42
 * @FilePath: /yhkh/src/config/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default {
  /**
   * @description 配置登录标题
   */
  loginTitle: process.env.VUE_APP_LOGIN_NAME,
  /**
   * @description 首页标题
   */
  homeTitle: process.env.VUE_APP_NAME,
  /**
   * @description 配置显示在浏览器标签的title
   */
  title: process.env.VUE_APP_TITLE,
  /**
   * @description 接口地址
   */
  appUrl: process.env.VUE_APP_URL,
  /**
   * @description websocket 地址
   */
  webUrl: process.env.VUE_APP_SOCKET_URL,
  /**
   * @description sso单点登录地址
   */
  ssoUrl: process.env.VUE_APP_SSO_URL,
  /**
   * @description sso单点登录home页地址
   */
  apiHomeIndex: process.env.VUE_APP_SSO_HOME_INDEX,
  /**
   * @description token在Cookie中存储的天数，默认1天
   */
  cookieExpires: 3,
  /**
   * @description 是否使用国际化，默认为false
   *              如果不使用，则需要在路由中给需要在菜单中展示的路由设置meta: {title: 'xxx'}
   *              用来在菜单中显示文字
   */
  useI18n: false,
  /**
   * @description api请求基础路径
   */
  baseUrl: {
    apiUrl: process.env.VUE_APP_URL,
    webSocketUrl: process.env.VUE_APP_SOCKET_URL
  },
  /**
   * @description 默认打开的首页的路由name值，默认为home
   */
  homeName: 'dashboard',
  /**
   * @description 是否支持sso登录，1为支持，0为不支持
   */
  sso: process.env.VUE_APP_SSO,
  /**
   * @description 需要加载的插件
   */
  centerLocation: process.env.VUE_APP_CENTER_LOCATION,
  plugin: {
    'error-store': {
      showInHeader: true, // 设为false后不会在顶部显示错误日志徽标
      developmentOff: true // 设为true后在开发环境不会收集错误信息，方便开发中排查错误
    }
  }
};
